import { Component } from '@angular/core';
import {HeroMoviLinkComponent} from "../../../app-persona/movi-link/hero-pages/hero-movi-link.component";

@Component({
  selector: 'app-hero-enterprise',
  standalone: true,
  imports: [],
  templateUrl: '../../../app-persona/movi-link/hero-pages/hero-movi-link.component.html',
  styleUrl: './hero-enterprise.component.css'
})
export class HeroEnterpriseComponent {
  title = 'Servicios Empresariales';
  subtitle1 = 'Colaboradores Sanos';
  subtitle2 = 'empresa más productiva';
  callToAction = '¡Escríbenos!';
  routeImageMain = 'assets/img/enterprise/bannerEmpresarial.svg';


}
